import RatingStars from '@/svg/rating-stars';
import styles from './styles.module.scss';

type ReviewBadgeProps = {
  logoSrc: string;
  logoAlt: string;
  score: string;
  starsVariant?: string;
};

const ReviewBadge = ({logoSrc, logoAlt, score, starsVariant}: ReviewBadgeProps) => (
  <div className={styles.badge}>
    <img src={logoSrc} alt={logoAlt} className={styles.logo} loading="lazy" />
    <p className={styles.score}>
      <span className={styles.score__main}>{score.split('/')[0]}</span>
      <span className={styles.score__denom}>/{score.split('/')[1]}</span>
    </p>
    <RatingStars variant={starsVariant} />
  </div>
);

export default ReviewBadge;
